export const ALL_FLAG_KEYS = [
  'qantas-activities-customer',
  'qantas-hotels-custom-inclusions',
  'qantas-hotels-optimizely-feature-event',
  'qantas-hotels-points-redemption-strikethrough',
  'qantas-hotels-price-strikethrough',
  'qantas-hotels-expt_6-remove_points_plus_pay',
  'qantas-hotels-tripadvisor-modal',
  'qantas-hotels-campaign-terms',
  'qantas-hotels-blue-banner-message',
  'qantas-hotels-yieldify-campaign',
  'qantas-hotels-vii-voucher-toggle',
  'vii-voucher-maintenance-toggle',
  'qantas-hotels-adyen-vault',
  'qantas-hotels-expt_5-book_another_room_cta',
  'qantas-hotels-expt_7-total_points_earned_on_deals_destinat_7f0s1',
  'qantas-hotels-salesforce-update',
];
